// extracted by mini-css-extract-plugin
export var attachment = "_pf-a";
export var emailContainer = "_pf-4";
export var emailContentPaddedContainer = "_pf-b";
export var emailHeader = "_pf-6";
export var emailIframe = "_pf-3";
export var emailInfoIcon = "_pf-9";
export var emailShortenedSummary = "_pf-e";
export var infoDropdown = "_pf-0";
export var infoRowBoundedContent = "_pf-d";
export var internal = "_pf-5";
export var merchant = "_pf-8";
export var messageInputContainer = "_pf-h";
export var normal = "_pf-7";
export var replyCard = "_pf-f";
export var subtleButton = "_pf-1";
export var subtleButtonIconContainer = "_pf-2";
export var toggleViewRepliesButton = "_pf-c";
export var wrappingText = "_pf-g";